(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-cart-drawer"]) return;
  try {
    
  (function () {
    // Event delegation on document — survives DOM replacement after Section
    // Rendering API re-render. Single source of truth state = body class
    // `rh-cart-drawer-open`.

    // Sprint fix-jnsp-cross-market — drawer-scoped auto-removal des lignes
    // JNSP cross-market. Symétrique cart-page mais sans reload : re-dispatch
    // rh:cart-updated post-removal pour déclencher Section Rendering API
    // re-render. Banner injectable dans .rh-cart-drawer__body au-dessus de
    // .rh-cart-drawer__items, re-render à chaque update DOM-replacement.
    var JNSP_SESSION_FLAG = 'rh:jnsp-geo-removed-drawer';

    function renderJnspBannerIfFlaggedDrawer() {
      if (sessionStorage.getItem(JNSP_SESSION_FLAG) !== '1') return;
      sessionStorage.removeItem(JNSP_SESSION_FLAG);
      var drawerBody = document.querySelector('.rh-cart-drawer__body');
      var itemsList = drawerBody && drawerBody.querySelector('.rh-cart-drawer__items');
      if (!drawerBody) return;
      var tEl = document.querySelector('script[data-rh-jnsp-banner-t-drawer]');
      var t = { title: '', body: '', dismissAria: 'Dismiss' };
      if (tEl) {
        try { t = JSON.parse(tEl.textContent); } catch (e) { console.error('[jnsp banner drawer] parse failed', e); }
      }
      var banner = document.createElement('aside');
      banner.className = 'rh-cart-drawer__jnsp-banner';
      banner.setAttribute('role', 'status');
      banner.innerHTML =
        '<div class="rh-cart-drawer__jnsp-banner-content">' +
          '<h3 class="rh-cart-drawer__jnsp-banner-title"></h3>' +
          '<p class="rh-cart-drawer__jnsp-banner-body"></p>' +
        '</div>' +
        '<button type="button" class="rh-cart-drawer__jnsp-banner-close" aria-label=""><svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 6L18 18M18 6L6 18"/></svg></button>';
      banner.querySelector('.rh-cart-drawer__jnsp-banner-title').textContent = t.title;
      banner.querySelector('.rh-cart-drawer__jnsp-banner-body').textContent = t.body;
      var closeBtn = banner.querySelector('.rh-cart-drawer__jnsp-banner-close');
      closeBtn.setAttribute('aria-label', t.dismissAria);
      closeBtn.addEventListener('click', function () { banner.remove(); });
      if (itemsList) {
        drawerBody.insertBefore(banner, itemsList);
      } else {
        drawerBody.insertBefore(banner, drawerBody.firstChild);
      }
    }

    function checkJnspCrossMarketDrawer() {
      if (window.Shopify && window.Shopify.country === 'FR') return;
      var drawer = document.querySelector('[data-rh-cart-drawer]');
      if (!drawer) return;
      var jnspLines = drawer.querySelectorAll('[data-rh-jnsp-line="true"]');
      if (jnspLines.length === 0) return;

      // Phase 2.8 — pattern /cart/update.js {updates: {variant_id: 0}}
      // atomique : symétrique cart-page (cf. checkJnspCrossMarket).
      var updates = {};
      jnspLines.forEach(function (lineEl) {
        var vid = lineEl.getAttribute('data-rh-variant-id');
        if (vid) updates[vid] = 0;
      });

      if (Object.keys(updates).length === 0) return;

      sessionStorage.setItem(JNSP_SESSION_FLAG, '1');

      var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(rootPath + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function (r) {
        if (!r.ok) throw new Error('update failed');
        return r.json();
      }).then(function () {
        document.dispatchEvent(new CustomEvent('rh:cart-updated', { detail: { source: 'jnsp-auto-removed' } }));
      }).catch(function (err) {
        console.error('[jnsp-cross-market drawer] auto-removal failed', err);
        sessionStorage.removeItem(JNSP_SESSION_FLAG);
      });
    }

    // Trigger initial au démarrage IIFE (load page) — couvre cas où drawer
    // contient déjà des items JNSP au render initial (ex: visiteur navigue
    // direct sur /cart ou /products après switch locale).
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        renderJnspBannerIfFlaggedDrawer();
        checkJnspCrossMarketDrawer();
      });
    } else {
      renderJnspBannerIfFlaggedDrawer();
      checkJnspCrossMarketDrawer();
    }

    // Transform animation duration on .rh-cart-drawer panel — must stay in sync
    // with the CSS transition: transform 0.3s.
    var DRAWER_TRANSITION_MS = 300;

    function openDrawer() {
      // Force one painted frame of the CLOSED state before flipping to OPEN.
      // After Section Rendering API replaceWith(), the freshly inserted DOM
      // node has no prior layout; adding the body class in the same task would
      // let the browser collapse first-paint and open-state into a single
      // frame, skipping the transform transition entirely. The double rAF
      // guarantees the first paint with transform: translateX(100%) has
      // committed, so the second frame's translateX(0) is interpolable.
      var drawer = document.querySelector('[data-rh-cart-drawer]');
      var overlay = document.querySelector('[data-rh-cart-drawer-overlay]');
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          document.body.classList.add('rh-cart-drawer-open');
          if (drawer) drawer.setAttribute('aria-hidden', 'false');
          if (overlay) overlay.setAttribute('aria-hidden', 'false');
        });
      });
    }

    function closeDrawer() {
      document.body.classList.remove('rh-cart-drawer-open');
      // Defer aria-hidden flip until after the slide-out completes so screen
      // readers don't announce the drawer as hidden while it's still visually
      // animating out.
      var drawer = document.querySelector('[data-rh-cart-drawer]');
      var overlay = document.querySelector('[data-rh-cart-drawer-overlay]');
      window.setTimeout(function () {
        if (drawer) drawer.setAttribute('aria-hidden', 'true');
        if (overlay) overlay.setAttribute('aria-hidden', 'true');
      }, DRAWER_TRANSITION_MS);
    }

    // Click delegation : close icon, overlay, continue shopping button, remove item.
    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-rh-cart-drawer-close]')) {
        event.preventDefault();
        closeDrawer();
        return;
      }
      if (event.target.closest('[data-rh-cart-drawer-overlay]')) {
        closeDrawer();
        return;
      }
      if (event.target.closest('[data-rh-cart-drawer-continue]')) {
        event.preventDefault();
        closeDrawer();
        return;
      }
      var removeBtn = event.target.closest('[data-rh-cart-drawer-remove]');
      if (removeBtn) {
        event.preventDefault();
        if (removeBtn.disabled) return;
        var line = parseInt(removeBtn.getAttribute('data-line'), 10);
        removeBtn.disabled = true;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ line: line, quantity: 0 })
        }).then(function (r) {
          if (!r.ok) throw new Error('remove failed');
          return r.json();
        }).then(function () {
          // Re-dispatch rh:cart-updated to refresh the drawer + header counter
          document.dispatchEvent(new CustomEvent('rh:cart-updated', { detail: { source: 'drawer-remove' } }));
        }).catch(function () {
          removeBtn.disabled = false;
        });
      }
    });

    // ESC key closes drawer
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (!document.body.classList.contains('rh-cart-drawer-open')) return;
      event.preventDefault();
      closeDrawer();
    });

    // ---- Main trigger ----
    // When an item is added to cart (via PDP ATC) OR removed from drawer,
    // fetch the updated drawer section HTML and replace the existing DOM.
    // Pattern : Shopify Section Rendering API. URL `/?sections=custom-cart-drawer`
    // returns JSON `{ "custom-cart-drawer": "<rendered section HTML>" }`.
    document.addEventListener('rh:cart-updated', function (event) {
      var detail = event.detail || {};
      var isRemove = detail.source === 'drawer-remove';

      fetch((window.Shopify?.routes?.root || '/') + '?sections=custom-cart-drawer', {
        headers: { 'Accept': 'application/json' }
      }).then(function (r) {
        if (!r.ok) throw new Error('section fetch failed');
        return r.json();
      }).then(function (data) {
        var html = data['custom-cart-drawer'];
        if (!html) return;
        // Replace the shopify-section wrapper. The section ID matches the
        // section filename without extension.
        var current = document.getElementById('shopify-section-custom-cart-drawer');
        if (!current) return;
        // Build a temporary container, extract the new section, swap it.
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newSection = doc.getElementById('shopify-section-custom-cart-drawer');
        if (newSection) {
          current.replaceWith(newSection);
        } else {
          // Fallback : if Shopify returns just the inner section content
          // (without the wrapper), replace innerHTML of the current wrapper.
          current.innerHTML = html;
        }
        // Sprint fix-jnsp-cross-market — post-replaceWith, le DOM drawer est
        // tout neuf. Re-trigger banner render (post-removal flagged) ET
        // re-check JNSP cross-market sur le nouveau contenu (cas où un autre
        // sprint dispatcherait rh:cart-updated avec un JNSP item présent).
        // Guard : si l'event provient de jnsp-auto-removed, ne pas re-checker
        // pour éviter une boucle infinie (rare, mais defensive).
        renderJnspBannerIfFlaggedDrawer();
        if (detail.source !== 'jnsp-auto-removed') {
          checkJnspCrossMarketDrawer();
        }
      }).catch(function (err) {
        // Silent fail : drawer keeps its previous state. Logging only.
        console.error('[rh-cart-drawer] section refresh failed:', err);
      }).finally(function () {
        // Open the drawer in all cases : after add (item just added, user
        // wants confirmation) OR after remove (so the user sees the updated
        // state). If the rh:cart-updated event was emitted by a different
        // surface (e.g., a future API), the drawer still opens to show
        // current cart state.
        // Exception : if remove brings cart to 0 items AND the trigger was a
        // drawer-remove, we still open to show the empty state.
        openDrawer();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-cart-page"]) return;
  try {
    
  // Sprint fix-jnsp-cross-market — Cart page auto-removal des lignes JNSP
  // si visiteur en contexte non-FR (cas FR ATC JNSP puis switch locale EN).
  // Lignes flaggées SSR via data-rh-jnsp-line="true" (cf. block Liquid for
  // item in cart.items). sessionStorage flag set avant reload pour afficher
  // le banner UX au load suivant via renderJnspBannerIfFlagged.
  (function () {
    var SESSION_FLAG = 'rh:jnsp-geo-removed';

    function renderJnspBannerIfFlagged() {
      if (sessionStorage.getItem(SESSION_FLAG) !== '1') return;
      sessionStorage.removeItem(SESSION_FLAG);
      var container = document.querySelector('.rh-cart__inner') || document.body;
      if (!container) return;
      var tEl = document.querySelector('script[data-rh-jnsp-banner-t]');
      var t = { title: '', body: '', dismissAria: 'Dismiss' };
      if (tEl) {
        try { t = JSON.parse(tEl.textContent); } catch (e) { console.error('[jnsp banner] parse failed', e); }
      }
      var banner = document.createElement('aside');
      banner.className = 'rh-cart__jnsp-banner';
      banner.setAttribute('role', 'status');
      banner.innerHTML =
        '<div class="rh-cart__jnsp-banner-content">' +
          '<h3 class="rh-cart__jnsp-banner-title"></h3>' +
          '<p class="rh-cart__jnsp-banner-body"></p>' +
        '</div>' +
        '<button type="button" class="rh-cart__jnsp-banner-close" aria-label=""><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 6L18 18M18 6L6 18"/></svg></button>';
      banner.querySelector('.rh-cart__jnsp-banner-title').textContent = t.title;
      banner.querySelector('.rh-cart__jnsp-banner-body').textContent = t.body;
      var closeBtn = banner.querySelector('.rh-cart__jnsp-banner-close');
      closeBtn.setAttribute('aria-label', t.dismissAria);
      closeBtn.addEventListener('click', function () { banner.remove(); });
      container.insertBefore(banner, container.firstChild);
    }

    function checkJnspCrossMarket() {
      if (window.Shopify && window.Shopify.country === 'FR') return;
      var jnspLines = document.querySelectorAll('[data-rh-jnsp-line="true"]');
      if (jnspLines.length === 0) return;

      // Phase 2.8 — pattern /cart/update.js {updates: {variant_id: 0}}
      // atomique : un seul appel, pas de renumérotation des line indexes
      // entre /cart/change.js séquentiels (qui vidait le panier).
      var updates = {};
      jnspLines.forEach(function (lineEl) {
        var vid = lineEl.getAttribute('data-rh-variant-id');
        if (vid) updates[vid] = 0;
      });

      if (Object.keys(updates).length === 0) return;

      sessionStorage.setItem(SESSION_FLAG, '1');

      var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(rootPath + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function (r) {
        if (!r.ok) throw new Error('update failed');
        return r.json();
      }).then(function () {
        window.location.reload();
      }).catch(function (err) {
        console.error('[jnsp-cross-market] auto-removal failed', err);
        sessionStorage.removeItem(SESSION_FLAG);
      });
    }

    function init() {
      renderJnspBannerIfFlagged();
      checkJnspCrossMarket();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  (function () {
    var section = document.querySelector('.rh-cart');
    if (!section) return;

    // Sprint impl-Cart.bis Phase 4b — postCartChange signature généralisée
    // accepting { line, quantity?, id?, properties? }. Refacto interne, comportement
    // legacy quantity+remove préservé via wrapper.
    function postCartChange(payload) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      });
    }

    // Phase 4b.quinquies — postCartAdd helper pour le pattern remove+add
    // (size click Cart cross-product variant swap : /cart/change.js id swap
    // renvoie 400 si new variant appartient à un autre product que le line item
    // current. Workaround : remove line + add new variant.
    function postCartAdd(payload) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      });
    }

    // Quantity selectors (+/-)
    section.querySelectorAll('[data-rh-cart-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var line = parseInt(btn.getAttribute('data-line'), 10);
        var direction = btn.getAttribute('data-rh-cart-qty'); // 'increase' or 'decrease'
        var lineEl = btn.closest('[data-rh-cart-line]');
        var valueEl = lineEl.querySelector('[data-rh-cart-qty-value]');
        var currentQty = parseInt(valueEl.textContent.trim(), 10);
        var newQty = direction === 'increase' ? currentQty + 1 : Math.max(0, currentQty - 1);
        if (newQty === currentQty) return;
        btn.disabled = true;
        postCartChange({ line: line, quantity: newQty }).then(function (r) {
          if (!r.ok) throw new Error('change failed');
          return r.json();
        }).then(function () {
          document.dispatchEvent(new CustomEvent('rh:cart-updated'));
          window.location.reload();
        }).catch(function () {
          btn.disabled = false;
        });
      });
    });

    // Remove buttons
    section.querySelectorAll('[data-rh-cart-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var line = parseInt(btn.getAttribute('data-line'), 10);
        btn.disabled = true;
        postCartChange({ line: line, quantity: 0 }).then(function (r) {
          if (!r.ok) throw new Error('remove failed');
          return r.json();
        }).then(function () {
          document.dispatchEvent(new CustomEvent('rh:cart-updated'));
          window.location.reload();
        }).catch(function () {
          btn.disabled = false;
        });
      });
    });

    // ────────────────────────────────────────────────────────────────────────
    // Sprint impl-Cart.bis Phase 4b — inline edit engraving + edit size.
    //
    // Modal handlers Cart-context. Engraving modal handlers PDP scope-isolés
    // IIFE → duplication contrôlée ici, scopée par modal-instance.
    // Multi-instance safe : modal-internal queries via modal.querySelector,
    // pas document-level. Pre-fill depuis data-attrs sur le trigger button.
    // ────────────────────────────────────────────────────────────────────────
    var ENGRAVING_ALLOWED_RE = /[a-zA-ZÀ-ÿ0-9 .,!?'\-&]/;
    function sanitizeEngravingText(s) {
      if (!s) return '';
      var out = '';
      for (var i = 0; i < s.length; i++) {
        var ch = s.charAt(i);
        if (ENGRAVING_ALLOWED_RE.test(ch)) out += ch;
      }
      return out;
    }
    function capitalize(s) {
      if (!s) return '';
      return s.charAt(0).toUpperCase() + s.slice(1);
    }

    document.addEventListener('rh:modal-opened', function (e) {
      var id = e.detail && e.detail.id;
      if (!id) return;

      // ── Cart-context engraving modal
      if (id.indexOf('rh-cart-engraving-modal-') === 0) {
        var lineIdx = id.substring('rh-cart-engraving-modal-'.length);
        var modal = document.getElementById(id);
        if (!modal) return;

        var trigger = document.querySelector('[data-rh-modal-open="' + id + '"]');
        var initialText = trigger ? (trigger.getAttribute('data-rh-engraving-initial-text') || '') : '';
        var initialFont = trigger ? (trigger.getAttribute('data-rh-engraving-initial-font') || 'trajan') : 'trajan';

        var input = modal.querySelector('[data-rh-engraving-input]');
        var countEl = modal.querySelector('[data-rh-engraving-count]');
        var counter = modal.querySelector('[data-rh-engraving-counter]');
        var preview = modal.querySelector('[data-rh-engraving-preview]');
        var fontBtns = modal.querySelectorAll('[data-rh-engraving-font]');
        var confirmBtn = modal.querySelector('[data-rh-engraving-confirm]');
        var removeBtn = modal.querySelector('[data-rh-engraving-remove]');

        if (!input || !confirmBtn) return;

        var draftFont = initialFont;

        function setPreviewFont(font) {
          if (!preview) return;
          preview.classList.remove(
            'rh-engraving-modal__preview-text--font-trajan',
            'rh-engraving-modal__preview-text--font-helvetica',
            'rh-engraving-modal__preview-text--font-garamond'
          );
          preview.classList.add('rh-engraving-modal__preview-text--font-' + font);
        }
        function updatePreview() {
          if (!preview) return;
          var raw = input.value;
          if (raw.length === 0) {
            preview.textContent = (window.rhLocales && window.rhLocales.pdp && window.rhLocales.pdp.engraving)
              ? window.rhLocales.pdp.engraving.preview_placeholder
              : '';
            preview.classList.add('rh-engraving-modal__preview-text--placeholder');
          } else {
            preview.textContent = raw;
            preview.classList.remove('rh-engraving-modal__preview-text--placeholder');
          }
        }
        function updateCounter() {
          if (!countEl || !counter) return;
          var len = input.value.length;
          countEl.textContent = String(len);
          if (len >= 23) counter.classList.add('is-near-limit');
          else counter.classList.remove('is-near-limit');
        }
        function updateConfirmEnabled() {
          confirmBtn.disabled = input.value.trim().length === 0;
        }
        function selectFont(font) {
          draftFont = font;
          fontBtns.forEach(function (b) {
            if (b.getAttribute('data-rh-engraving-font') === font) b.classList.add('is-selected');
            else b.classList.remove('is-selected');
          });
          setPreviewFont(font);
        }

        // Pre-fill
        input.value = initialText;
        selectFont(initialFont);
        updateCounter();
        updatePreview();
        updateConfirmEnabled();
        if (removeBtn) removeBtn.hidden = initialText.length === 0;

        // Wire up input + font + confirm + remove (idempotent via __rhCartBound guard)
        if (!input.__rhCartBound) {
          input.__rhCartBound = true;
          input.addEventListener('keypress', function (event) {
            var key = event.key;
            if (!key || key.length !== 1) return;
            if (!ENGRAVING_ALLOWED_RE.test(key)) event.preventDefault();
          });
          input.addEventListener('input', function () {
            var sanitized = sanitizeEngravingText(input.value);
            if (sanitized !== input.value) input.value = sanitized;
            updateCounter();
            updatePreview();
            updateConfirmEnabled();
          });
        }
        fontBtns.forEach(function (b) {
          if (b.__rhCartBound) return;
          b.__rhCartBound = true;
          b.addEventListener('click', function () {
            selectFont(b.getAttribute('data-rh-engraving-font'));
          });
        });
        if (!confirmBtn.__rhCartBound) {
          confirmBtn.__rhCartBound = true;
          confirmBtn.addEventListener('click', function () {
            if (confirmBtn.disabled) return;
            var text = input.value.trim();
            if (!text) return;
            confirmBtn.disabled = true;
            postCartChange({
              line: parseInt(lineIdx, 10),
              properties: {
                'Engraving Text': text,
                'Engraving Font': capitalize(draftFont)
              }
            }).then(function (r) {
              if (!r.ok) throw new Error('change failed');
              window.location.reload();
            }).catch(function () {
              confirmBtn.disabled = false;
            });
          });
        }
        if (removeBtn && !removeBtn.__rhCartBound) {
          removeBtn.__rhCartBound = true;
          removeBtn.addEventListener('click', function () {
            if (removeBtn.disabled) return;
            removeBtn.disabled = true;
            // Q3 figé : clear properties via empty object
            postCartChange({
              line: parseInt(lineIdx, 10),
              properties: {}
            }).then(function (r) {
              if (!r.ok) throw new Error('change failed');
              window.location.reload();
            }).catch(function () {
              removeBtn.disabled = false;
            });
          });
        }
      }

      // ── Cart-context size modal (Phase 4b.quater)
      // Branche modal-opened : ne fait QUE la prep visuelle (unhide buttons +
      // hide empty state). Le click handler size est désormais en delegation
      // document-level (cf. block dédié plus bas) pour robustesse maximale —
      // immune aux issues de timing rh:modal-opened vs dialog.showModal()
      // top-layer rendering, immune aux issues de closure scope, immune aux
      // guards __rhCartBound. Pattern aligné sur custom-modal.js delegation
      // pour [data-rh-modal-open] (L109-117).
      if (id.indexOf('rh-cart-size-modal-') === 0) {
        var sizeModal = document.getElementById(id);
        if (!sizeModal) return;
        // Show all size buttons (size-only swap, Material × Stone fixed in Cart context)
        sizeModal.querySelectorAll('[data-rh-size]').forEach(function (b) { b.hidden = false; });
        var emptyEl = sizeModal.querySelector('[data-rh-size-empty]');
        if (emptyEl) emptyEl.hidden = true;
      }
    });

    // ── Cart-context size click — document-level delegation (Phase 4b.quater)
    // + Phase 4b.quinquies remove+add workaround.
    //
    // Cause root Phase 4b.quater : /cart/change.js { line, id } renvoie 400
    // Bad Request quand newVariantId appartient à un autre product que le
    // line item current (catalogue Rosenhart = 1 product par variant cross-axis,
    // contrainte Shopify Cart API product-scoped variant swap).
    //
    // Workaround Phase 4b.quinquies : séquence remove+add atomique avec
    // rollback en cas d'échec mid-flight.
    //   1. POST /cart/change.js { line: N, quantity: 0 } → remove current line
    //   2. POST /cart/add.js { id: newVariantId, quantity: 1, properties: preserved }
    //   3. reload
    // Si étape 2 échoue → rollback re-add original variant + properties + reload.
    document.addEventListener('click', function (event) {
      var sizeBtn = event.target.closest('[data-rh-size]');
      if (!sizeBtn) return;
      var sizeDialog = sizeBtn.closest('dialog[id^="rh-cart-size-modal-"]');
      if (!sizeDialog) return;
      if (sizeBtn.disabled) return;

      var sizeLineIdx = sizeDialog.id.substring('rh-cart-size-modal-'.length);
      var sizeVal = sizeBtn.getAttribute('data-rh-size');

      // Re-read variants JSON map fresh from DOM (filtered SSR Material × Stone combo)
      var jsonScript = document.querySelector('[data-rh-cart-line-variants="' + sizeLineIdx + '"]');
      var variantsMap = {};
      if (jsonScript) {
        try { variantsMap = JSON.parse(jsonScript.textContent) || {}; } catch (e) {}
      }
      var newVariantId = variantsMap[sizeVal];

      if (!newVariantId) {
        var emptyEl = sizeDialog.querySelector('[data-rh-size-empty]');
        if (emptyEl) emptyEl.hidden = false;
        return;
      }

      // Lookup trigger button (porte data-rh-cart-original-variant-id + scope ligne)
      var sizeTrigger = document.querySelector('[data-rh-modal-open="' + sizeDialog.id + '"]');
      var originalVariantId = sizeTrigger ? parseInt(sizeTrigger.getAttribute('data-rh-cart-original-variant-id'), 10) : null;

      // Q4 figé : preserve existing engraving properties on variant swap.
      // Re-read fresh from sibling engraving trigger same line if present.
      var engravingTrigger = document.querySelector('[data-rh-modal-open="rh-cart-engraving-modal-' + sizeLineIdx + '"]');
      var preservedProperties = {};
      if (engravingTrigger) {
        var t = engravingTrigger.getAttribute('data-rh-engraving-initial-text');
        var f = engravingTrigger.getAttribute('data-rh-engraving-initial-font');
        if (t) {
          preservedProperties['Engraving Text'] = t;
          preservedProperties['Engraving Font'] = capitalize(f || 'trajan');
        }
      }

      sizeBtn.disabled = true;

      // Sprint impl-Cart.bis Phase 4b.quinquies — séquence remove + add avec rollback.
      (function () {
        // Étape 1 : remove current line
        postCartChange({ line: parseInt(sizeLineIdx, 10), quantity: 0 }).then(function (removeRes) {
          if (!removeRes.ok) {
            console.error('[rh-cart] size remove failed', removeRes.status);
            sizeBtn.disabled = false;
            return;
          }

          // Étape 2 : add new variant + preserved properties
          var addPayload = { id: parseInt(newVariantId, 10), quantity: 1 };
          if (Object.keys(preservedProperties).length > 0) {
            addPayload.properties = preservedProperties;
          }

          postCartAdd(addPayload).then(function (addRes) {
            if (addRes.ok) {
              window.location.reload();
              return;
            }

            // Étape 3 : rollback — re-add original variant + properties
            console.error('[rh-cart] size add failed', addRes.status, '— attempting rollback');
            var rollbackPayload = { id: originalVariantId, quantity: 1 };
            if (Object.keys(preservedProperties).length > 0) {
              rollbackPayload.properties = preservedProperties;
            }
            postCartAdd(rollbackPayload).then(function (rollbackRes) {
              if (!rollbackRes.ok) {
                console.error('[rh-cart] size rollback FAILED — cart now missing this line');
                var lang = document.documentElement.lang || 'fr';
                alert(
                  lang.indexOf('en') === 0
                    ? 'Size change failed. Please refresh and try again.'
                    : 'Le changement de taille a échoué. Veuillez rafraîchir la page et réessayer.'
                );
              }
              window.location.reload();
            }).catch(function (rollbackErr) {
              console.error('[rh-cart] size rollback exception', rollbackErr);
              window.location.reload();
            });
          }).catch(function (addErr) {
            console.error('[rh-cart] size add exception', addErr);
            sizeBtn.disabled = false;
          });
        }).catch(function (removeErr) {
          console.error('[rh-cart] size remove exception', removeErr);
          sizeBtn.disabled = false;
        });
      })();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-collection-grid"]) return;
  try {
    
  (function () {
    // Both .rh-card--gold AND .rh-card--silver get cross-axis interactivity
    // when they have data-variants attached (Gina silver gets stone swatches).
    // Sprint impl-cards-shop: extended to swap hover image (data-card-img-hover)
    // when the new variant has a hover_image field in data-variants JSON.
    var cards = document.querySelectorAll('.rh-card[data-variants]');
    if (!cards.length) return;

    cards.forEach(function (card) {
      if (card.__rhBound) return;
      card.__rhBound = true;

      var raw = card.getAttribute('data-variants');
      if (!raw) return;
      var variants;
      try { variants = JSON.parse(raw); } catch (e) { return; }
      if (!variants || !variants.length) return;

      var img = card.querySelector('[data-card-img]');
      var imgHover = card.querySelector('[data-card-img-hover]');
      var priceEl = card.querySelector('[data-card-price]');
      var handle = card.getAttribute('data-product-handle');
      var hasStones = card.querySelectorAll('[data-axis="stone"]').length > 0;

      var activeMaterial = card.getAttribute('data-hero-material');
      var activeStone = hasStones ? card.getAttribute('data-hero-stone') : null;

      function findVariant(material, stone) {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          if (v.material !== material) continue;
          if (stone) {
            if (v.stone === stone) return v;
          } else {
            return v;
          }
        }
        // Fallback: first variant matching material regardless of stone
        if (stone) {
          for (var j = 0; j < variants.length; j++) {
            if (variants[j].material === material) return variants[j];
          }
        }
        return null;
      }

      function applyVariant(v) {
        if (!v) return;

        // Sprint cards-typo round 2 — subtitle Material · Stone update
        // au swatch click. v.material / v.stone déjà locale-aware via
        // SSR data-variants Liquid (Markets ProductOptionValue
        // translationsRegister Sprint 9.6.Y batch 3). has_stone détection
        // implicite via v.stone undefined OU défini (shape JSON
        // conditionnelle snippet L583 gold-no-stone).
        var subtitleEl = card.querySelector('.rh-card__subtitle');
        if (subtitleEl && v.material) {
          var subtitle = v.material;
          if (v.stone) subtitle += ' · ' + v.stone;
          subtitleEl.textContent = subtitle;
        }

        if (img && v.image) {
          img.src = v.image;
          img.removeAttribute('srcset');
          var altParts = [v.material];
          if (v.stone) altParts.push(v.stone);
          img.setAttribute('alt', altParts.join(' / '));
        }
        if (imgHover) {
          if (v.hover_image) {
            imgHover.src = v.hover_image;
            imgHover.removeAttribute('srcset');
            imgHover.style.display = '';
          } else {
            imgHover.style.display = 'none';
          }
        }
        if (priceEl && v.price) priceEl.textContent = v.price;
        if (handle && v.id) card.setAttribute('href', '/products/' + handle + '?variant=' + v.id);
      }

      var swatches = card.querySelectorAll('.rh-card__swatch[data-axis]');
      swatches.forEach(function (swatch) {
        swatch.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          var axis = swatch.getAttribute('data-axis');
          var value = swatch.getAttribute('data-value');

          // Toggle active state within the same axis only
          card.querySelectorAll('[data-axis="' + axis + '"]').forEach(function (s) {
            s.classList.remove('is-active');
            s.removeAttribute('aria-current');
          });
          swatch.classList.add('is-active');
          swatch.setAttribute('aria-current', 'true');

          if (axis === 'material') activeMaterial = value;
          else activeStone = value;

          applyVariant(findVariant(activeMaterial, activeStone));
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-header"]) return;
  try {
    
  (function () {
    var header = document.querySelector('.rh-header');
    if (!header) return;

    var SCROLL_THRESHOLD = 100;
    var ticking = false;

    function updateScrollState() {
      if (window.scrollY > SCROLL_THRESHOLD) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(updateScrollState);
        ticking = true;
      }
    }, { passive: true });

    updateScrollState();

    // Maintain --header-height / --header-group-height for downstream Horizon components
    // that read these CSS vars (they would otherwise be left unset since we replaced
    // the header-group section).
    function setHeaderVars() {
      var height = header.offsetHeight;
      document.body.style.setProperty('--header-height', height + 'px');
      document.body.style.setProperty('--header-group-height', height + 'px');
    }
    setHeaderVars();
    window.addEventListener('resize', setHeaderVars);

    // Mobile drawer (Sprint A) — hamburger toggles a slide-in <aside>.
    // The body class `rh-mobile-menu-open` is the single source of truth
    // for drawer state (CSS rules consume it for transform + overflow lock).
    // Aria labels read from data-aria-open / data-aria-close set at render
    // time from rh.header.menu_*_aria locale keys (see docs/I18N.md sec 14.8).
    var hamburger = header.querySelector('[data-rh-hamburger]');
    var drawer = header.querySelector('[data-rh-mobile-drawer]');
    var drawerOverlay = header.querySelector('[data-rh-mobile-drawer-overlay]');

    if (hamburger && drawer && drawerOverlay) {
      function getDrawerFocusables() {
        return drawer.querySelectorAll(
          'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
        );
      }

      function openDrawer() {
        document.body.classList.add('rh-mobile-menu-open');
        hamburger.setAttribute('aria-expanded', 'true');
        hamburger.setAttribute('aria-label', hamburger.dataset.ariaClose);
        drawer.setAttribute('aria-hidden', 'false');
        drawerOverlay.removeAttribute('hidden');
        // Defer focus to next frame so the CSS transition has started and the
        // browser can deliver focus into the now-visible drawer cleanly.
        var first = getDrawerFocusables()[0];
        if (first) window.requestAnimationFrame(function () { first.focus(); });
      }

      function closeDrawer() {
        document.body.classList.remove('rh-mobile-menu-open');
        hamburger.setAttribute('aria-expanded', 'false');
        hamburger.setAttribute('aria-label', hamburger.dataset.ariaOpen);
        drawer.setAttribute('aria-hidden', 'true');
        drawerOverlay.setAttribute('hidden', '');
        hamburger.focus();
      }

      hamburger.addEventListener('click', function () {
        if (document.body.classList.contains('rh-mobile-menu-open')) {
          closeDrawer();
        } else {
          openDrawer();
        }
      });

      drawerOverlay.addEventListener('click', closeDrawer);

      // ESC closes the drawer if open. Sharing the listener with the locale
      // dropdown ESC handler below — both gate on their own open state.
      document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        if (!document.body.classList.contains('rh-mobile-menu-open')) return;
        event.preventDefault();
        closeDrawer();
      });

      // Focus trap: Tab cycles within the drawer while it's open.
      drawer.addEventListener('keydown', function (event) {
        if (event.key !== 'Tab') return;
        if (!document.body.classList.contains('rh-mobile-menu-open')) return;
        var focusables = getDrawerFocusables();
        if (focusables.length === 0) return;
        var first = focusables[0];
        var last = focusables[focusables.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
    }

    // ---- Locale selector dropdown (Sprint 8.1.B.2) ----
    var localeSelector = header.querySelector('[data-rh-locale-selector]');
    var localeTrigger  = header.querySelector('[data-rh-locale-trigger]');
    var localeDropdown = header.querySelector('[data-rh-locale-dropdown]');

    if (localeSelector && localeTrigger && localeDropdown) {
      function openLocale() {
        localeSelector.classList.add('is-open');
        localeTrigger.setAttribute('aria-expanded', 'true');
        localeDropdown.hidden = false;
        // Focus the current option if one exists, else the first option.
        var preferred = localeDropdown.querySelector('.rh-header__market-option.is-current')
                     || localeDropdown.querySelector('.rh-header__market-option');
        if (preferred) preferred.focus();
      }
      function closeLocale(returnFocus) {
        localeSelector.classList.remove('is-open');
        localeTrigger.setAttribute('aria-expanded', 'false');
        localeDropdown.hidden = true;
        if (returnFocus) localeTrigger.focus();
      }

      localeTrigger.addEventListener('click', function (event) {
        event.stopPropagation();
        if (localeSelector.classList.contains('is-open')) {
          closeLocale(true);
        } else {
          openLocale();
        }
      });

      // Click outside the selector closes the dropdown.
      document.addEventListener('click', function (event) {
        if (!localeSelector.classList.contains('is-open')) return;
        if (localeSelector.contains(event.target)) return;
        closeLocale(false);
      });

      // ESC closes (and returns focus to the trigger).
      document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        if (!localeSelector.classList.contains('is-open')) return;
        event.preventDefault();
        closeLocale(true);
      });

    }

    // Sprint F.2 Composante B — 2 distinct localization forms (replaces Sprint
    // 9.6.Y batch 2 single-form locale_code injection).
    //   - Language forms (id contains "language"): inject locale_code from
    //     submitter's data-rh-locale-lang. No country_code → preserves market.
    //   - Location forms (id contains "location"): submit native country_code
    //     only. No locale_code injection → Shopify preserves current locale
    //     when destination market lists it in alternateLocales.
    // Forms target both desktop dropdown and mobile drawer instances (id suffix
    // "-drawer" on mobile). Matched via shared "rh-locale-form-" prefix.
    var localeForms = header.querySelectorAll('form[id^="rh-locale-form-"]');
    localeForms.forEach(function (form) {
      form.addEventListener('submit', function (event) {
        if (form.id.indexOf('language') === -1) return;
        var btn = event.submitter;
        var lang = btn && btn.dataset ? btn.dataset.rhLocaleLang : null;
        if (!lang) return;
        var hidden = form.querySelector('input[name="locale_code"]');
        if (!hidden) {
          hidden = document.createElement('input');
          hidden.type = 'hidden';
          hidden.name = 'locale_code';
          form.appendChild(hidden);
        }
        hidden.value = lang;
      });
    });

    // ── Cart counter live update (Sprint impl-Cart Phase 3) ─────────────
    // Subscribe to `rh:cart-updated` events dispatched by PDP ATC + cart
    // page (qty change / remove) + cart drawer (remove). Refresh count and
    // parens visibility from /cart.js. No Section Rendering API — overkill
    // for two values, and /cart.js works in preview (no password gate on
    // the JSON endpoint, unlike `/?sections=…`).
    document.addEventListener('rh:cart-updated', function () {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var countEl = document.querySelector('[data-rh-cart-count]');
          var parensEl = document.querySelector('[data-rh-cart-count-parens]');
          if (countEl) countEl.textContent = cart.item_count;
          if (parensEl) parensEl.hidden = cart.item_count === 0;
        })
        .catch(function (err) {
          console.error('[header cart counter] fetch /cart.js failed', err);
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-home-grid"]) return;
  try {
    
  (function () {
    // Duplicate of the swatch swap handler from custom-collection-grid.liquid.
    // Required because Shopify section JS bundles are loaded per-section-type,
    // not globally. Home + Shop never coexist on the same page so no listener
    // collision risk.
    var cards = document.querySelectorAll('.rh-card[data-variants]');
    if (!cards.length) return;

    cards.forEach(function (card) {
      if (card.__rhBound) return;
      card.__rhBound = true;

      var raw = card.getAttribute('data-variants');
      if (!raw) return;
      var variants;
      try { variants = JSON.parse(raw); } catch (e) { return; }
      if (!variants || !variants.length) return;

      var img = card.querySelector('[data-card-img]');
      var imgHover = card.querySelector('[data-card-img-hover]');
      var priceEl = card.querySelector('[data-card-price]');
      var handle = card.getAttribute('data-product-handle');
      var hasStones = card.querySelectorAll('[data-axis="stone"]').length > 0;

      var activeMaterial = card.getAttribute('data-hero-material');
      var activeStone = hasStones ? card.getAttribute('data-hero-stone') : null;

      function findVariant(material, stone) {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          if (v.material !== material) continue;
          if (stone) {
            if (v.stone === stone) return v;
          } else {
            return v;
          }
        }
        if (stone) {
          for (var j = 0; j < variants.length; j++) {
            if (variants[j].material === material) return variants[j];
          }
        }
        return null;
      }

      function applyVariant(v) {
        if (!v) return;

        // Sprint cards-typo round 2 — subtitle Material · Stone update
        // au swatch click. v.material / v.stone déjà locale-aware via
        // SSR data-variants Liquid (Markets ProductOptionValue
        // translationsRegister Sprint 9.6.Y batch 3). has_stone détection
        // implicite via v.stone undefined OU défini (shape JSON
        // conditionnelle snippet L583 gold-no-stone).
        var subtitleEl = card.querySelector('.rh-card__subtitle');
        if (subtitleEl && v.material) {
          var subtitle = v.material;
          if (v.stone) subtitle += ' · ' + v.stone;
          subtitleEl.textContent = subtitle;
        }

        if (img && v.image) {
          img.src = v.image;
          img.removeAttribute('srcset');
          var altParts = [v.material];
          if (v.stone) altParts.push(v.stone);
          img.setAttribute('alt', altParts.join(' / '));
        }
        if (imgHover) {
          if (v.hover_image) {
            imgHover.src = v.hover_image;
            imgHover.removeAttribute('srcset');
            imgHover.style.display = '';
          } else {
            imgHover.style.display = 'none';
          }
        }
        if (priceEl && v.price) priceEl.textContent = v.price;
        if (handle && v.id) card.setAttribute('href', '/products/' + handle + '?variant=' + v.id);
      }

      var swatches = card.querySelectorAll('.rh-card__swatch[data-axis]');
      swatches.forEach(function (swatch) {
        swatch.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          var axis = swatch.getAttribute('data-axis');
          var value = swatch.getAttribute('data-value');

          card.querySelectorAll('[data-axis="' + axis + '"]').forEach(function (s) {
            s.classList.remove('is-active');
            s.removeAttribute('aria-current');
          });
          swatch.classList.add('is-active');
          swatch.setAttribute('aria-current', 'true');

          if (axis === 'material') activeMaterial = value;
          else activeStone = value;

          applyVariant(findVariant(activeMaterial, activeStone));
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-page-customer-care"]) return;
  try {
    
  (function () {
    var triggers = document.querySelectorAll('.rh-cc__accordion-trigger');
    triggers.forEach(function (t) {
      t.addEventListener('click', function () {
        var open = t.getAttribute('aria-expanded') === 'true';
        t.setAttribute('aria-expanded', open ? 'false' : 'true');
        var panel = t.nextElementSibling;
        if (panel) panel.hidden = open;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-pdp-cross-sell"]) return;
  try {
    
  (function () {
    // Sprint impl-cards-shop Phase 2.quater — duplicate of the swatch swap
    // handler from custom-collection-grid.liquid / custom-home-grid.liquid.
    // Required because cross-sell renders the snippet rh-product-card which
    // emits .rh-card[data-variants] markup; without this handler swatches
    // wouldn't be interactive on the PDP cross-sell. __rhBound guard prevents
    // double-binding if multiple section JS bundles co-exist on the page.
    var cards = document.querySelectorAll('.rh-card[data-variants]');
    if (!cards.length) return;

    cards.forEach(function (card) {
      if (card.__rhBound) return;
      card.__rhBound = true;

      var raw = card.getAttribute('data-variants');
      if (!raw) return;
      var variants;
      try { variants = JSON.parse(raw); } catch (e) { return; }
      if (!variants || !variants.length) return;

      var img = card.querySelector('[data-card-img]');
      var imgHover = card.querySelector('[data-card-img-hover]');
      var priceEl = card.querySelector('[data-card-price]');
      var handle = card.getAttribute('data-product-handle');
      var hasStones = card.querySelectorAll('[data-axis="stone"]').length > 0;

      var activeMaterial = card.getAttribute('data-hero-material');
      var activeStone = hasStones ? card.getAttribute('data-hero-stone') : null;

      function findVariant(material, stone) {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          if (v.material !== material) continue;
          if (stone) {
            if (v.stone === stone) return v;
          } else {
            return v;
          }
        }
        if (stone) {
          for (var j = 0; j < variants.length; j++) {
            if (variants[j].material === material) return variants[j];
          }
        }
        return null;
      }

      function applyVariant(v) {
        if (!v) return;

        // Sprint cards-typo round 2 — subtitle Material · Stone update
        // au swatch click. v.material / v.stone déjà locale-aware via
        // SSR data-variants Liquid (Markets ProductOptionValue
        // translationsRegister Sprint 9.6.Y batch 3). has_stone détection
        // implicite via v.stone undefined OU défini (shape JSON
        // conditionnelle snippet L583 gold-no-stone).
        var subtitleEl = card.querySelector('.rh-card__subtitle');
        if (subtitleEl && v.material) {
          var subtitle = v.material;
          if (v.stone) subtitle += ' · ' + v.stone;
          subtitleEl.textContent = subtitle;
        }

        if (img && v.image) {
          img.src = v.image;
          img.removeAttribute('srcset');
          var altParts = [v.material];
          if (v.stone) altParts.push(v.stone);
          img.setAttribute('alt', altParts.join(' / '));
        }
        if (imgHover) {
          if (v.hover_image) {
            imgHover.src = v.hover_image;
            imgHover.removeAttribute('srcset');
            imgHover.style.display = '';
          } else {
            imgHover.style.display = 'none';
          }
        }
        if (priceEl && v.price) priceEl.textContent = v.price;
        if (handle && v.id) card.setAttribute('href', '/products/' + handle + '?variant=' + v.id);
      }

      var swatches = card.querySelectorAll('.rh-card__swatch[data-axis]');
      swatches.forEach(function (swatch) {
        swatch.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          var axis = swatch.getAttribute('data-axis');
          var value = swatch.getAttribute('data-value');

          card.querySelectorAll('[data-axis="' + axis + '"]').forEach(function (s) {
            s.classList.remove('is-active');
            s.removeAttribute('aria-current');
          });
          swatch.classList.add('is-active');
          swatch.setAttribute('aria-current', 'true');

          if (axis === 'material') activeMaterial = value;
          else activeStone = value;

          applyVariant(findVariant(activeMaterial, activeStone));
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-pdp-main"]) return;
  try {
    
  (function () {
    var section = document.querySelector('.rh-pdp');
    if (!section) return;

    var hasStone = section.getAttribute('data-has-stone') === 'true';
    var handle = section.getAttribute('data-product-handle');

    // ────────────────────────────────────────────────────────────────────────
    //  Sprint fix-pdp-variant-selector.B — variants fetched via Storefront API
    //  GraphQL (replaces the prior /products/{handle}.js fetch from Sprint
    //  9.5.B Phase 3 round 5).
    //
    //  Root cause for the swap: /products/{handle}.js is hard-capped at 250
    //  variants by Shopify, regardless of `?limit=` / `?page=` params and
    //  regardless of `.json` alt endpoint (audit Phase 1 confirmed empirically
    //  on 4 endpoints). Liquid `product.variants` is capped at 250 too. Gina
    //  No. 1 / No. 2 have 330 variants each → 80 variants unreachable from JS.
    //  Visible: certain Material × Stone combos completely missing or sizes
    //  >57-58 unavailable (Phase 1 §A.3).
    //
    //  Storefront API GraphQL `productByHandle.variants(first, after)` paginates
    //  via cursor and returns all variants. We iterate hasNextPage until
    //  exhausted and concat. The shim layer below maps the GraphQL node format
    //  to the legacy /products.js format so findVariant / applyVariant /
    //  filterSizesForCurrent / ATC handlers (audit Phase 1 §B.1) work unchanged.
    //
    //  Path-driven locale rule: the Storefront API URL is root-absolute
    //  (`/api/<version>/graphql.json`, no market subfolder prefix) → returns
    //  shop primary locale (EN canonical option values), matching the EN
    //  backbone Pattern 7 surface 4 (`data-value-en` swatch attribute) added
    //  Sprint fix-pdp-variant-selector main. Cf. ARCHITECTURE.md §7.2bis.
    //
    //  Storefront API token: provisioned by Thomas via Shopify Admin → Apps →
    //  Develop apps → custom app with `unauthenticated_read_product_listings`
    //  scope. Tokens are public-readable by design (Shopify documented), no
    //  leak risk in theme code. The placeholder below is grep-able.
    //
    //  Graceful degradation: if token unset OR network/GraphQL error, fetch
    //  resolves to []. filterSizesForCurrent returns true (show all sizes)
    //  while !variantsReady, so the UI stays usable; only id-dependent flows
    //  (size click → applyVariant, ATC → resolved variant id) are no-ops.
    // ────────────────────────────────────────────────────────────────────────
    var STOREFRONT_API_TOKEN = '0af0499100a9afbd247222d9a8261c29';
    var STOREFRONT_API_VERSION = '2024-10';
    var STOREFRONT_API_URL = '/api/' + STOREFRONT_API_VERSION + '/graphql.json';

    window.__rhVariantsByHandle = window.__rhVariantsByHandle || {};
    var variants = window.__rhVariantsByHandle[handle] || [];
    var variantsReady = variants.length > 0;
    var variantsReadyCallbacks = [];

    function whenVariantsReady(cb) {
      if (variantsReady) { cb(variants); return; }
      variantsReadyCallbacks.push(cb);
    }

    function setVariantsReady(arr) {
      variants = arr || [];
      window.__rhVariantsByHandle[handle] = variants;
      variantsReady = true;
      variantsReadyCallbacks.forEach(function (cb) {
        try { cb(variants); } catch (e) {}
      });
      variantsReadyCallbacks = [];
    }

    // Shim a Storefront API GraphQL ProductVariant node into the /products.js
    // variant shape consumed by findVariant / applyVariant downstream.
    //   - GraphQL id = "gid://shopify/ProductVariant/41234567890" → numeric id
    //   - price.amount is a decimal string ("790.00") → cents integer (79000)
    //   - selectedOptions[] is ordered by option position 1, 2, 3 per Shopify
    //     spec → maps directly to option1 / option2 / option3.
    //   - availableForSale (bool) → available (bool).
    function shimGraphQLVariant(node) {
      var so = node.selectedOptions || [];
      return {
        id: parseInt(String(node.id).split('/').pop(), 10),
        option1: so[0] ? so[0].value : null,
        option2: so[1] ? so[1].value : null,
        option3: so[2] ? so[2].value : null,
        price: Math.round(parseFloat(node.price.amount) * 100),
        available: !!node.availableForSale
      };
    }

    // Fetch all variants for a product via Storefront API GraphQL with cursor
    // pagination. Returns Promise<array<shimmed variant>>. Empty array on any
    // error path (token missing, network, GraphQL error, malformed payload).
    function fetchAllVariantsGraphQL(productHandle) {
      if (STOREFRONT_API_TOKEN === '__REPLACE_ME_AFTER_SHOPIFY_PROVISIONING__') {
        console.error('[rh-pdp] Storefront API token not configured');
        return Promise.resolve([]);
      }

      var query =
        'query($handle: String!, $cursor: String) @inContext(language: EN) {' +
        '  productByHandle(handle: $handle) {' +
        '    variants(first: 250, after: $cursor) {' +
        '      pageInfo { hasNextPage endCursor }' +
        '      edges { node {' +
        '        id' +
        '        selectedOptions { name value }' +
        '        price { amount currencyCode }' +
        '        availableForSale' +
        '      } }' +
        '    }' +
        '  }' +
        '}';

      var collected = [];

      function fetchPage(cursor) {
        return fetch(STOREFRONT_API_URL, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Shopify-Storefront-Access-Token': STOREFRONT_API_TOKEN
          },
          body: JSON.stringify({
            query: query,
            variables: { handle: productHandle, cursor: cursor || null }
          })
        }).then(function (r) {
          if (!r.ok) throw new Error('Storefront API HTTP ' + r.status);
          return r.json();
        }).then(function (payload) {
          if (payload.errors && payload.errors.length) {
            throw new Error('Storefront API GraphQL: ' + JSON.stringify(payload.errors));
          }
          var product = payload.data && payload.data.productByHandle;
          if (!product) throw new Error('Storefront API: product not found');
          var conn = product.variants;
          var edges = (conn && conn.edges) || [];
          for (var i = 0; i < edges.length; i++) {
            collected.push(shimGraphQLVariant(edges[i].node));
          }
          if (conn && conn.pageInfo && conn.pageInfo.hasNextPage) {
            return fetchPage(conn.pageInfo.endCursor);
          }
          return collected;
        });
      }

      return fetchPage(null).catch(function (err) {
        console.error('[rh-pdp] Storefront API fetch failed', err);
        return [];
      });
    }

    if (!variantsReady) {
      fetchAllVariantsGraphQL(handle).then(function (vs) {
        setVariantsReady(vs || []);
      });
    }

    var gallery = section.querySelector('[data-pdp-gallery]');
    var subtitleEl = section.querySelector('[data-pdp-subtitle]');
    var priceEl = section.querySelector('[data-pdp-price]');
    var klarnaEl = section.querySelector('[data-pdp-klarna]');
    // Sprint 7.4.1: keep the modal schedule synced with the active variant.
    var klarnaTodayEl = document.querySelector('[data-rh-klarna-today]');
    var klarna30dEl   = document.querySelector('[data-rh-klarna-30d]');
    var klarna60dEl   = document.querySelector('[data-rh-klarna-60d]');
    var materialLabelEl = section.querySelector('[data-pdp-material-label]');
    var stoneLabelEl = section.querySelector('[data-pdp-stone-label]');
    var sizeTrigger = section.querySelector('[data-rh-size-trigger]');
    var sizeTriggerValueEl = section.querySelector('[data-rh-size-trigger-value]');
    var sizeModal = document.getElementById('rh-size-modal');
    var sizeGrid = sizeModal && sizeModal.querySelector('[data-rh-size-grid]');
    var sizeEmpty = sizeModal && sizeModal.querySelector('[data-rh-size-empty]');
    var sizeUnknownBtn = sizeModal && sizeModal.querySelector('.rh-size-modal__unknown');
    var atcBtn = section.querySelector('[data-pdp-atc]');

    var SPECIAL_SIZE = 'Je ne sais pas (recevez gratuitement votre baguier)';

    // ────────────────────────────────────────────────────────────────────────
    //  Initial state — read from DOM (SSR has already baked the active swatch
    //  classes, the size trigger value, and the ATC data-variant-id from
    //  current_variant). Replaces the prior `variants[0]` fallback which is
    //  no longer available before the products.js fetch resolves.
    // ────────────────────────────────────────────────────────────────────────
    function readDomState() {
      var matEl = section.querySelector('.rh-pdp__swatch[data-axis="material"].is-active');
      var stoneEl = section.querySelector('.rh-pdp__swatch[data-axis="stone"].is-active');
      var sizeValEl = section.querySelector('[data-rh-size-trigger-value]');
      var sizeText = sizeValEl ? (sizeValEl.textContent || '').trim() : '';
      // The size trigger may show "Select your size" placeholder pre-selection.
      var sizeIsPlaceholder = (sizeText === '' || sizeText === window.rhLocales.pdp.size.placeholder);
      // Backbone EN-anchored: read data-value-en (Pattern 7 §14.8 — 4th
      // surface, added Sprint fix-pdp-variant-selector). v.option1/option2
      // from /products.js are always EN canonical regardless of market
      // locale, so the backbone must be EN to make findVariant cross EN-EN.
      // Display labels (subtitle, .rh-pdp__option-value textContent) and the
      // materialMediaMap lookup key (built SSR locale-aware) are derived
      // separately from data-value in the swatch click handler and in
      // applyVariant via a reverse DOM lookup.
      return {
        material: matEl ? matEl.getAttribute('data-value-en') : null,
        stone: stoneEl ? stoneEl.getAttribute('data-value-en') : null,
        size: sizeIsPlaceholder ? null : sizeText,
      };
    }

    var current = readDomState();

    // findVariant — works against the fetched products.js variants. Returns
    // null until variantsReady. The caller is responsible for either deferring
    // (whenVariantsReady) or accepting null.
    // products.js field mapping: option1 = Material, option2 = Stone (if
    // hasStone) or Size (otherwise), option3 = Size (if hasStone).
    function findVariant(material, stone, size) {
      if (!variants.length) return null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (v.option1 !== material) continue;
        if (hasStone) {
          if (v.option2 !== stone) continue;
          if (v.option3 !== size) continue;
        } else {
          if (v.option2 !== size) continue;
        }
        return v;
      }
      return null;
    }

    // Helper: compose the canonical variant_display key used by the SSR
    // materialMediaMap and ALT contract.
    function composeLookupKey(material, stone) {
      if (hasStone && stone) return material + ', ' + stone;
      return material;
    }

    // Price formatter — products.js gives `price` in cents. We format using
    // Intl.NumberFormat with the storefront's locale + currency when available
    // (window.Shopify.currency.active). Output should match the SSR `money`
    // filter for the active market in most cases (FR 'EUR' → "790,00 €").
    var _shopifyLocale = (window.Shopify && Shopify.locale) || 'fr-FR';
    var _shopifyCurrency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    var _priceFormatter;
    try {
      _priceFormatter = new Intl.NumberFormat(_shopifyLocale, {
        style: 'currency', currency: _shopifyCurrency
      });
    } catch (e) { _priceFormatter = null; }
    function formatPrice(cents) {
      if (cents == null) return '';
      var amount = cents / 100;
      if (_priceFormatter) return _priceFormatter.format(amount);
      return amount.toFixed(2).replace('.', ',') + ' €';
    }

    // Single-image fallback (loaded once). Narrower than product.media so we
    // don't mix images from other materials in the gallery.
    var fallbackImage = [];
    var fbEl = document.getElementById('rh-pdp-fallback-image');
    if (fbEl) {
      try { fallbackImage = JSON.parse(fbEl.textContent); } catch (e) { fallbackImage = []; }
    }

    // Sprint 9.5.B — Material → {video, images[]} lookup.
    // Drives the entire gallery from product.media (filtered by Material ALT
    // at SSR time). variant.media is no longer consulted because Shopify's
    // variant-media constraints make multi-media-per-variant impossible via
    // API (see the gallery comment block in the SSR section above for the
    // full analysis of the 5 stacked constraints we hit).
    var materialMediaMap = {};
    var mvEl = document.getElementById('rh-pdp-material-media');
    if (mvEl) {
      try { materialMediaMap = JSON.parse(mvEl.textContent) || {}; } catch (e) { materialMediaMap = {}; }
    }

    // Sprint fix-pdp-details-reactivity — per-material / per-stone DETAILS map,
    // parsed from the SSR JSON embed (id="rh-pdp-details-map"). Keyed EN backbone
    // (rh-variant-en twin), aligned with the swatch data-value-en read by
    // readDomState(). Drives updateDetails() on swatch click — synchronous,
    // DOM-driven, independent of variantsReady, so it also reacts on a DRAFT
    // preview where the Storefront API returns no variants.
    var detailsMap = {};
    var dmEl = document.getElementById('rh-pdp-details-map');
    if (dmEl) {
      try { detailsMap = JSON.parse(dmEl.textContent) || {}; } catch (e) { detailsMap = {}; }
    }

    // updateDetails — refresh the Material/Stone-dependent DETAILS hooks (material
    // value, ⓘ tooltip, weight, stone type) to match the current combo. matEN /
    // stoneEN are EN-backbone values (data-value-en). No variant lookup needed:
    // the four fields are pure Material/Stone functions baked SSR into detailsMap.
    // Called from the swatch handler (Step 6); size clicks never change
    // Material/Stone so DETAILS is not touched there. Works catalogue-wide,
    // rings included (the map is built from the current product's option values).
    function updateDetails(matEN, stoneEN) {
      var mat = detailsMap.materials && detailsMap.materials[matEN];
      if (mat) {
        var mEl = section.querySelector('[data-pdp-detail="material"]');
        if (mEl) mEl.textContent = mat.enriched;
        var wEl = section.querySelector('[data-pdp-detail="weight"]');
        if (wEl && mat.weight != null) wEl.textContent = mat.weight;
        var ttWrap = section.querySelector('[data-pdp-detail="material-tooltip"]');
        if (ttWrap) {
          var ttBtn = ttWrap.querySelector('.rh-pdp__tooltip-trigger');
          if (ttBtn) {
            if (mat.tooltip) {
              ttBtn.setAttribute('data-tooltip', mat.tooltip);
              ttBtn.setAttribute('aria-label', mat.tooltip);
              ttBtn.hidden = false;
            } else {
              ttBtn.removeAttribute('data-tooltip');
              ttBtn.removeAttribute('aria-label');
              ttBtn.hidden = true;
            }
          }
        }
      }
      if (hasStone && stoneEN) {
        var stone = detailsMap.stones && detailsMap.stones[stoneEN];
        if (stone) {
          section.querySelectorAll('[data-pdp-detail="stone-type"]').forEach(function (el) {
            el.textContent = el.getAttribute('data-stone-form') === 'plural' ? stone.plural : stone.single;
          });
        }
      }
    }

    function renderGallery(media, variantDisplay) {
      if (!gallery) return;

      // Build the gallery list from materialMediaMap[variantDisplay] when
      // available (Sprint 9.5.B target architecture, Phase 3 keyed by
      // variant_display = "Material" or "Material, Stone"). The legacy `media`
      // argument is a backward-compatible fallback for products that haven't
      // been migrated to per-variant_display product.media yet — those keep
      // their variant.media array and the prior cascade.
      var list = null;
      if (variantDisplay && materialMediaMap[variantDisplay]) {
        var mm = materialMediaMap[variantDisplay];
        list = [];
        if (mm.video) {
          list.push({
            type: 'video',
            original: mm.video.original || null,
            sources: mm.video.sources || [],
            poster: mm.video.poster || null,
            alt: mm.video.alt || ''
          });
        }
        if (mm.images && mm.images.length) {
          mm.images.forEach(function (img) {
            list.push({ type: 'image', src: img.src, alt: img.alt || '' });
          });
        }
        if (list.length === 0) list = null;
      }
      if (!list) {
        // Backward-compat cascade: variant media → fallback image → keep DOM
        list = (media && media.length) ? media.slice()
               : (fallbackImage.length ? fallbackImage.slice() : null);
      }
      if (!list) return;  // never wipe — leave the existing DOM in place

      gallery.innerHTML = '';
      list.forEach(function (m, i) {
        var wrap = document.createElement('div');
        // Sprint 9.5.B (round 2) — apply the same desktop alternation pattern
        // to the JS-rebuilt gallery: every 3rd item (i % 3 === 0) spans both
        // grid columns. Mobile uses flex (not grid), so this class is a no-op
        // there — flex children ignore grid-column.
        var classes = 'rh-pdp__media';
        if (m.type !== 'image') classes += ' rh-pdp__media--video';
        if (i % 3 === 0) classes += ' rh-pdp__media--full';
        wrap.className = classes;
        if (m.type === 'image') {
          var img = document.createElement('img');
          img.className = 'rh-pdp__img';
          img.src = m.src;
          img.alt = m.alt || '';
          img.loading = i === 0 ? 'eager' : 'lazy';
          img.width = 1200;
          img.height = 1500;
          wrap.appendChild(img);
        } else {
          var v = document.createElement('video');
          v.className = 'rh-pdp__video';
          v.autoplay = true;
          v.muted = true;
          v.loop = true;
          v.playsInline = true;
          v.preload = 'metadata';
          if (m.poster) v.poster = m.poster;
          v.setAttribute('aria-label', m.alt || window.rhLocales.pdp.video_aria_fallback);
          // Sprint video-original-pdp — mirror the SSR priority: uploaded
          // original master first (single source, DEC-051: no <source media>),
          // DEC-046 sorted renditions as fallback.
          if (m.original) {
            var srcOriginal = document.createElement('source');
            srcOriginal.src = m.original;
            srcOriginal.type = 'video/mp4';
            v.appendChild(srcOriginal);
          } else if (m.sources && m.sources.length) {
            m.sources.forEach(function (s) {
              var src = document.createElement('source');
              src.src = s.url;
              if (s.mime_type) src.type = s.mime_type;
              v.appendChild(src);
            });
          } else if (m.src) {
            v.src = m.src;
          }
          wrap.appendChild(v);
        }
        gallery.appendChild(wrap);
      });
    }

    // applyVariant — now consumes a products.js variant object (option1/2/3,
    // price as cents, available, id). Formats price client-side and computes
    // klarna locally. Updates current state, all info-column DOM bindings,
    // ATC button data-variant-id, URL, and the gallery via materialMediaMap.
    function applyVariant(v) {
      if (!v) return;
      var matVal = v.option1;
      var stoneVal = hasStone ? v.option2 : null;
      var sizeVal = hasStone ? v.option3 : v.option2;

      // Update tracked current state (EN backbone — matVal/stoneVal come
      // from /products.js which is always EN canonical, so subsequent
      // findVariant calls cross EN-EN).
      current.material = matVal;
      current.stone = stoneVal;
      current.size = sizeVal;
      current.id = String(v.id);

      // Reverse-lookup the locale-aware display values from the SSR swatch
      // markup (data-value-en EN backbone → data-value locale-aware). Used
      // for subtitle + .rh-pdp__option-value textContent so the FR visitor
      // still sees "Argent · Diamant de synthèse blanc" instead of "Silver
      // · White Lab Diamond" after a size click that resolves a new variant.
      var matDisplaySwatch = section.querySelector('.rh-pdp__swatch[data-axis="material"][data-value-en="' + matVal + '"]');
      var matDisplay = matDisplaySwatch ? matDisplaySwatch.getAttribute('data-value') : matVal;
      var stoneDisplay = null;
      if (hasStone && stoneVal) {
        var stoneDisplaySwatch = section.querySelector('.rh-pdp__swatch[data-axis="stone"][data-value-en="' + stoneVal + '"]');
        stoneDisplay = stoneDisplaySwatch ? stoneDisplaySwatch.getAttribute('data-value') : stoneVal;
      }

      // Subtitle (Material · Stone) — display layer locale-aware
      if (subtitleEl) {
        var sub = matDisplay;
        if (hasStone && stoneDisplay) sub += ' · ' + stoneDisplay;
        // Sprint 2B — pendant chain suffix (short form). Empty string for rings
        // (injected via window.rhLocales SSR, is_pendant-gated) → no-op, subtitle
        // stays byte-identical for rings. Re-appended here so a published pendant
        // keeps the suffix after this textContent rebuild.
        if (window.rhLocales.pdp.chain_suffix_short) sub += ' ' + window.rhLocales.pdp.chain_suffix_short;
        subtitleEl.textContent = sub;
      }

      // Price + klarna (client-side cents → formatted string)
      var priceStr = formatPrice(v.price);
      var third = Math.floor(v.price / 3);
      var today = v.price - 2 * third;
      var thirdStr = formatPrice(third);
      var todayStr = formatPrice(today);
      if (priceEl) priceEl.textContent = priceStr;
      if (klarnaEl) klarnaEl.innerHTML = escapeHtml(window.rhLocales.pdp.klarna.trigger_prefix) + escapeHtml(thirdStr) + escapeHtml(window.rhLocales.pdp.klarna.trigger_suffix);
      if (klarnaTodayEl) klarnaTodayEl.textContent = todayStr;
      if (klarna30dEl)   klarna30dEl.textContent   = thirdStr;
      if (klarna60dEl)   klarna60dEl.textContent   = thirdStr;

      // Selector labels (display layer locale-aware via reverse swatch lookup)
      if (materialLabelEl) materialLabelEl.textContent = matDisplay;
      if (stoneLabelEl && stoneDisplay) stoneLabelEl.textContent = stoneDisplay;

      // Size trigger label + filled state
      updateSizeTrigger(sizeVal);

      // Refresh size grid (filter by current Material × Stone) + selected highlight
      filterSizesForCurrent();

      // Add to Bag state
      if (atcBtn) {
        atcBtn.setAttribute('data-variant-id', String(v.id));
        atcBtn.disabled = !v.available;
      }

      // Gallery — pass the canonical variant_display key. materialMediaMap is
      // built SSR locale-aware (key = mv_display from product.options_with_values
      // which is FR in FR context, EN in EN context), so the lookup must use
      // the display-layer values matDisplay/stoneDisplay (reverse-resolved
      // l.2106-2112 from the active swatch data-value). Using matVal/stoneVal
      // (EN backbone from v.option1/option2) would miss the map in FR and
      // collapse the gallery to the single fallback image. Sprint
      // fix-pdp-variant-selector Phase 2 patch round 2.
      renderGallery(null, composeLookupKey(matDisplay, stoneDisplay));

      // URL
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', String(v.id));
        history.replaceState({}, '', url);
      } catch (e) { /* ignore */ }
    }

    function escapeHtml(s) {
      return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    // ────────────────────────────────────────────────────────────────────────
    //  Swatch click handler — Sprint 9.5.B Phase 3 round 5.
    //
    //  Decoupled from the variants payload: the gallery swap is driven entirely
    //  by the SSR materialMediaMap (which itself enumerates options × options
    //  × product.media at SSR time and never touches product.variants). The
    //  click flow:
    //    1. Update DOM .is-active for the clicked swatch's axis.
    //    2. Read DOM state (current material + stone after the click).
    //    3. Compose the canonical lookup key.
    //    4. If materialMediaMap[key] is missing (e.g. Silver × Pink Lab Diamond
    //       on Gina — combo intentionally excluded from the spec), reset the
    //       OTHER axis to the first available combo for the clicked axis value.
    //    5. Render the gallery from the map.
    //    6. Update info-column labels (subtitle, Material, Stone) immediately.
    //    7. Defer price / Klarna / URL / ATC data-variant-id update until the
    //       /products.js fetch completes — find the matching variant for the
    //       current Material × Stone × Size and apply the rest via applyVariant.
    //       If the current size doesn't exist for the new combo, fallback to
    //       the first available variant of that combo and reset the size trigger.
    // ────────────────────────────────────────────────────────────────────────
    section.querySelectorAll('.rh-pdp__swatch[data-axis]').forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        var axis = swatch.getAttribute('data-axis');

        // Step 1: update active state in this axis only
        section.querySelectorAll('.rh-pdp__swatch[data-axis="' + axis + '"]').forEach(function (s) {
          s.classList.remove('is-active');
          s.removeAttribute('aria-current');
        });
        swatch.classList.add('is-active');
        swatch.setAttribute('aria-current', 'true');

        // Step 2: read DOM state after the click — Pattern 7 dual-flow:
        //   domState.material/stone are EN-anchored (data-value-en) used as
        //   the findVariant backbone (matches v.option1/option2 from
        //   /products.js, always EN canonical regardless of market).
        //   materialDisplay/stoneDisplay are locale-aware (data-value) used
        //   for the display layer (subtitle, .rh-pdp__option-value text) AND
        //   for the materialMediaMap lookup (the map is built SSR via
        //   mv_display = product.options_with_values[i].values, which is
        //   locale-aware — so the lookup key must also be the display value,
        //   not the EN backbone, or we'd miss the map in FR context).
        var domState = readDomState();
        var activeMatSwatch = section.querySelector('.rh-pdp__swatch[data-axis="material"].is-active');
        var activeStoneSwatch = section.querySelector('.rh-pdp__swatch[data-axis="stone"].is-active');
        var materialDisplay = activeMatSwatch ? activeMatSwatch.getAttribute('data-value') : null;
        var stoneDisplay = activeStoneSwatch ? activeStoneSwatch.getAttribute('data-value') : null;
        var lookupKey = composeLookupKey(materialDisplay, stoneDisplay);

        // Step 3-4: if combo doesn't exist (e.g. Silver × Pink Gina), reset
        // the OTHER axis to the first available combo for the clicked axis.
        if (hasStone && !materialMediaMap[lookupKey]) {
          var prefix = materialDisplay + ', ';
          var altStone = null;
          var keys = Object.keys(materialMediaMap);
          for (var k = 0; k < keys.length; k++) {
            if (keys[k].indexOf(prefix) === 0) {
              altStone = keys[k].slice(prefix.length);
              break;
            }
          }
          if (altStone) {
            // altStone is the display locale value (matches the map key,
            // built SSR locale-aware). Re-activate the matching stone swatch
            // and pick up its EN backbone via data-value-en so domState.stone
            // stays aligned for findVariant.
            var altStoneSwatch = null;
            section.querySelectorAll('.rh-pdp__swatch[data-axis="stone"]').forEach(function (s) {
              if (s.getAttribute('data-value') === altStone) {
                s.classList.add('is-active');
                s.setAttribute('aria-current', 'true');
                altStoneSwatch = s;
              } else {
                s.classList.remove('is-active');
                s.removeAttribute('aria-current');
              }
            });
            stoneDisplay = altStone;
            if (altStoneSwatch) domState.stone = altStoneSwatch.getAttribute('data-value-en');
            lookupKey = composeLookupKey(materialDisplay, stoneDisplay);
          }
        }

        // Step 5: render gallery from the map (synchronous, no variants needed)
        renderGallery(null, lookupKey);

        // Step 6: update labels immediately (display layer, locale-aware)
        if (subtitleEl) {
          var sub = materialDisplay;
          if (hasStone && stoneDisplay) sub += ' · ' + stoneDisplay;
          // Sprint 2B — pendant chain suffix (short form). Empty for rings → no-op.
          if (window.rhLocales.pdp.chain_suffix_short) sub += ' ' + window.rhLocales.pdp.chain_suffix_short;
          subtitleEl.textContent = sub;
        }
        if (materialLabelEl) materialLabelEl.textContent = materialDisplay;
        if (stoneLabelEl && stoneDisplay) stoneLabelEl.textContent = stoneDisplay;

        // Sprint fix-pdp-details-reactivity — refresh the DETAILS accordion
        // synchronously from the DOM state (EN backbone). Independent of
        // variantsReady → reacts on DRAFT preview too (Meredith No. 1).
        updateDetails(domState.material, hasStone ? domState.stone : null);

        // Update tracked current state (EN backbone — used by
        // filterSizesForCurrent, size click handler, findVariant; matches
        // v.option1/option2 from /products.js).
        current.material = domState.material;
        current.stone = domState.stone;

        // Step 7: defer price / Klarna / URL / ATC data-variant-id update
        whenVariantsReady(function () {
          var v = findVariant(domState.material, domState.stone, domState.size);
          var sizeUnavailable = !v;
          if (sizeUnavailable) {
            // Pick first available variant in the new combo (EN backbone)
            for (var i = 0; i < variants.length; i++) {
              var vv = variants[i];
              if (vv.option1 !== domState.material) continue;
              if (hasStone && vv.option2 !== domState.stone) continue;
              if (vv.available) { v = vv; break; }
            }
          }
          if (v) {
            applyVariant(v);
            if (sizeUnavailable) {
              // Force the trigger back to "Select your size" so the user re-picks
              // intentionally (Sprint 7.2 spec point 5). ATC is disabled too.
              updateSizeTrigger(null);
              if (atcBtn) atcBtn.disabled = true;
            }
          }
        });
      });
    });

    // ---- Size modal logic (Sprint 7.2) ----
    function updateSizeTrigger(sizeValue) {
      if (!sizeTrigger || !sizeTriggerValueEl) return;
      if (!sizeValue || sizeValue === window.rhLocales.pdp.size.placeholder) {
        sizeTriggerValueEl.textContent = window.rhLocales.pdp.size.placeholder;
        sizeTrigger.classList.remove('is-filled');
        return;
      }
      sizeTriggerValueEl.textContent = sizeValue;
      sizeTrigger.classList.add('is-filled');
    }

    // Show/hide size buttons based on what's available for the current Material × Stone.
    // Also re-marks the currently selected button. Returns true if at least one is shown.
    // If variants aren't loaded yet, show all sizes (graceful degradation —
    // /products.js typically resolves <300ms after page load).
    function filterSizesForCurrent() {
      if (!sizeGrid) return true;
      var btns = sizeGrid.querySelectorAll('.rh-size-modal__btn');
      var anyShown = false;
      var currentSize = current ? current.size : null;
      btns.forEach(function (btn) {
        var size = btn.getAttribute('data-rh-size');
        var show = true;
        if (variantsReady) {
          var match = findVariant(
            current.material,
            hasStone ? current.stone : null,
            size
          );
          show = !!match;
        }
        btn.hidden = !show;
        if (show) anyShown = true;
        if (size === currentSize) {
          btn.classList.add('is-selected');
        } else {
          btn.classList.remove('is-selected');
        }
      });
      if (sizeEmpty) sizeEmpty.hidden = anyShown;
      if (sizeUnknownBtn) {
        if (currentSize === SPECIAL_SIZE) {
          sizeUnknownBtn.classList.add('is-selected');
        } else {
          sizeUnknownBtn.classList.remove('is-selected');
        }
      }
      return anyShown;
    }
    // Re-run filter once variants are loaded (modal may already be on page).
    whenVariantsReady(function () { filterSizesForCurrent(); });

    // Click on a size button (numeric or "unknown") inside the modal
    if (sizeModal) {
      sizeModal.addEventListener('click', function (event) {
        var btn = event.target.closest('[data-rh-size]');
        if (!btn) return;
        event.preventDefault();
        var size = btn.getAttribute('data-rh-size');
        // Defer until variants are loaded (Phase 3 round 5: variants are
        // fetched async via /products.js — typically ready within 300ms).
        whenVariantsReady(function () {
          var v = findVariant(current.material, hasStone ? current.stone : null, size);
          if (!v) return;
          applyVariant(v);
          if (window.rhModal) window.rhModal.close('rh-size-modal');
        });
      });
    }

    // When the modal opens, refresh the grid + pre-select the active size
    document.addEventListener('rh:modal-opened', function (event) {
      if (!event.detail || event.detail.id !== 'rh-size-modal') return;
      filterSizesForCurrent();
    });

    // Initial render: filter the grid for the variant Liquid resolved at load
    filterSizesForCurrent();

    // ---- Engraving modal logic (Sprint 7.3) ----
    // Allowed in engraving text: latin letters (incl. accents À-ÿ), digits,
    // spaces, and a few punctuation marks. Emojis and exotic symbols are
    // blocked at keypress and stripped from pastes.
    var ENGRAVING_ALLOWED_RE = /[a-zA-ZÀ-ÿ0-9 .,!?'\-&]/;
    function sanitizeEngravingText(s) {
      var out = '';
      for (var i = 0; i < s.length; i++) {
        var ch = s.charAt(i);
        if (ENGRAVING_ALLOWED_RE.test(ch)) out += ch;
      }
      return out.slice(0, 25);
    }
    function capitalize(s) {
      if (!s) return '';
      return s.charAt(0).toUpperCase() + s.slice(1);
    }

    var currentEngraving = null;            // committed state {text, font} or null
    var engravingDraftFont = 'trajan';      // staged font in the open modal (not yet committed)

    var engravingInput      = document.querySelector('[data-rh-engraving-input]');
    var engravingCounter    = document.querySelector('[data-rh-engraving-counter]');
    var engravingCount      = document.querySelector('[data-rh-engraving-count]');
    var engravingFontBtns   = document.querySelectorAll('[data-rh-engraving-font]');
    var engravingPreview    = document.querySelector('[data-rh-engraving-preview]');
    var engravingConfirmBtn = document.querySelector('[data-rh-engraving-confirm]');
    var engravingRemoveBtn  = document.querySelector('[data-rh-engraving-remove]');
    var engravingSummary    = section.querySelector('[data-rh-engraving-summary]');
    var engravingSummaryText= section.querySelector('[data-rh-engraving-summary-text]');

    function setPreviewFont(font) {
      if (!engravingPreview) return;
      engravingPreview.classList.remove(
        'rh-engraving-modal__preview-text--font-trajan',
        'rh-engraving-modal__preview-text--font-helvetica',
        'rh-engraving-modal__preview-text--font-garamond'
      );
      engravingPreview.classList.add('rh-engraving-modal__preview-text--font-' + font);
    }

    function updateEngravingPreview() {
      if (!engravingPreview) return;
      var raw = engravingInput ? engravingInput.value : '';
      if (raw.length === 0) {
        engravingPreview.textContent = window.rhLocales.pdp.engraving.preview_placeholder;
        engravingPreview.classList.add('rh-engraving-modal__preview-text--placeholder');
      } else {
        engravingPreview.textContent = raw;
        engravingPreview.classList.remove('rh-engraving-modal__preview-text--placeholder');
      }
    }

    function updateEngravingCounter() {
      if (!engravingInput || !engravingCount || !engravingCounter) return;
      var len = engravingInput.value.length;
      engravingCount.textContent = String(len);
      if (len >= 23) {
        engravingCounter.classList.add('is-near-limit');
      } else {
        engravingCounter.classList.remove('is-near-limit');
      }
    }

    function updateConfirmEnabled() {
      if (!engravingConfirmBtn || !engravingInput) return;
      var hasText = engravingInput.value.trim().length > 0;
      engravingConfirmBtn.disabled = !hasText;
    }

    function selectEngravingFont(font) {
      engravingDraftFont = font;
      engravingFontBtns.forEach(function (btn) {
        if (btn.getAttribute('data-rh-engraving-font') === font) {
          btn.classList.add('is-selected');
        } else {
          btn.classList.remove('is-selected');
        }
      });
      setPreviewFont(font);
    }

    function refreshEngravingSummary() {
      if (!engravingSummary || !engravingSummaryText) return;
      // Sprint impl-PDP Phase 2a.quinquies — retrait suffix " (Font)" + apply
      // selected font on the summary text via .rh-pdp__engraving-rectangle__summary--font-*
      // CSS class (pattern aligné modale Engraving preview).
      engravingSummaryText.classList.remove(
        'rh-pdp__engraving-rectangle__summary--font-trajan',
        'rh-pdp__engraving-rectangle__summary--font-helvetica',
        'rh-pdp__engraving-rectangle__summary--font-garamond'
      );
      if (currentEngraving) {
        engravingSummaryText.textContent = currentEngraving.text;
        engravingSummaryText.classList.add(
          'rh-pdp__engraving-rectangle__summary--font-' + currentEngraving.font
        );
        engravingSummary.hidden = false;
      } else {
        engravingSummary.hidden = true;
        engravingSummaryText.textContent = '';
      }
    }

    if (engravingInput) {
      engravingInput.addEventListener('keypress', function (event) {
        // Some browsers emit keypress with empty key for control keys; skip those.
        var key = event.key;
        if (!key || key.length !== 1) return;
        if (!ENGRAVING_ALLOWED_RE.test(key)) event.preventDefault();
      });
      engravingInput.addEventListener('paste', function (event) {
        event.preventDefault();
        var pasted = (event.clipboardData || window.clipboardData).getData('text');
        var clean = sanitizeEngravingText(pasted);
        // Insert clean text at the caret, respecting maxlength 25 overall.
        var start = engravingInput.selectionStart || 0;
        var end = engravingInput.selectionEnd || 0;
        var current = engravingInput.value;
        var next = (current.slice(0, start) + clean + current.slice(end)).slice(0, 25);
        engravingInput.value = next;
        var caret = Math.min(start + clean.length, 25);
        try { engravingInput.setSelectionRange(caret, caret); } catch (e) { /* ignore */ }
        updateEngravingCounter();
        updateEngravingPreview();
        updateConfirmEnabled();
      });
      engravingInput.addEventListener('input', function () {
        // Strip any disallowed characters that may have slipped in (IME, etc.)
        var sanitized = sanitizeEngravingText(engravingInput.value);
        if (sanitized !== engravingInput.value) engravingInput.value = sanitized;
        updateEngravingCounter();
        updateEngravingPreview();
        updateConfirmEnabled();
      });
    }

    engravingFontBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectEngravingFont(btn.getAttribute('data-rh-engraving-font'));
      });
    });

    if (engravingConfirmBtn) {
      engravingConfirmBtn.addEventListener('click', function () {
        if (engravingConfirmBtn.disabled) return;
        var text = engravingInput.value.trim();
        if (!text) return;
        currentEngraving = { text: text, font: engravingDraftFont };
        refreshEngravingSummary();
        if (window.rhModal) window.rhModal.close('rh-engraving-modal');
        document.dispatchEvent(new CustomEvent('rh:engraving-set', { detail: currentEngraving }));
      });
    }

    // Remove engraving (Sprint 7.3.1): clear the committed state, hide the
    // summary, close the modal, broadcast the removal.
    if (engravingRemoveBtn) {
      engravingRemoveBtn.addEventListener('click', function () {
        currentEngraving = null;
        refreshEngravingSummary();
        if (window.rhModal) window.rhModal.close('rh-engraving-modal');
        document.dispatchEvent(new CustomEvent('rh:engraving-removed'));
      });
    }

    // When the engraving modal opens: pre-fill from currentEngraving (edit mode)
    // or reset to empty/Trajan default (first-time mode). Also toggles the
    // "Remove engraving" button visibility (only shown in edit mode).
    document.addEventListener('rh:modal-opened', function (event) {
      if (!event.detail || event.detail.id !== 'rh-engraving-modal') return;
      if (currentEngraving) {
        engravingInput.value = currentEngraving.text;
        selectEngravingFont(currentEngraving.font);
        if (engravingRemoveBtn) engravingRemoveBtn.hidden = false;
      } else {
        engravingInput.value = '';
        selectEngravingFont('trajan');
        if (engravingRemoveBtn) engravingRemoveBtn.hidden = true;
      }
      updateEngravingCounter();
      updateEngravingPreview();
      updateConfirmEnabled();
      // Move focus into the text input for keyboard users
      if (engravingInput) setTimeout(function () { engravingInput.focus(); }, 0);
    });

    // Add to Bag handler — Phase 3 round 5: resolve variant from window
    // .__rhVariantsByHandle[handle] at click time. The data-variant-id on the
    // button is also kept in sync by applyVariant for backward-compat fallback.
    if (atcBtn) {
      atcBtn.addEventListener('click', function () {
        if (atcBtn.disabled) return;
        // Resolve current variant from DOM state via fetched variants list.
        var domState = readDomState();
        var resolvedV = findVariant(
          domState.material,
          hasStone ? domState.stone : null,
          domState.size
        );
        var vid = resolvedV ? String(resolvedV.id) : atcBtn.getAttribute('data-variant-id');
        if (!vid) return;
        atcBtn.disabled = true;
        var origText = atcBtn.textContent;
        atcBtn.textContent = window.rhLocales.pdp.atc.adding;

        // Inject engraving as line item properties when present (Sprint 7.3)
        var payload = { id: vid, quantity: 1 };
        if (currentEngraving) {
          payload.properties = {
            'Engraving Text': currentEngraving.text,
            'Engraving Font': capitalize(currentEngraving.font)
          };
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload)
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        }).then(function () {
          atcBtn.textContent = window.rhLocales.pdp.atc.added;
          document.dispatchEvent(new CustomEvent('rh:cart-updated'));
          setTimeout(function () {
            atcBtn.textContent = origText;
            atcBtn.disabled = false;
          }, 1500);
        }).catch(function () {
          atcBtn.textContent = window.rhLocales.pdp.atc.try_again;
          setTimeout(function () {
            atcBtn.textContent = origText;
            atcBtn.disabled = false;
          }, 1500);
        });
      });
    }

    // Accordion handlers
    section.querySelectorAll('.rh-pdp__accordion-trigger').forEach(function (t) {
      t.addEventListener('click', function () {
        var open = t.getAttribute('aria-expanded') === 'true';
        t.setAttribute('aria-expanded', open ? 'false' : 'true');
        var panel = t.nextElementSibling;
        if (panel) panel.hidden = open;
      });
    });

    // NOTE: do NOT call applyVariant(current) at load.
    // The Liquid render is already correct (Shopify resolves ?variant= server-side
    // and current_variant points to the right one). Calling applyVariant() here
    // would wipe the Liquid-rendered gallery via renderGallery's `innerHTML = ''`
    // and bail out if the variant's media JSON is empty for any reason — leaving
    // an empty gallery DOM. Variant switching only happens on user click below.

    // Sprint 9.5.B — Mobile carousel progress bar.
    // Updates the foreground bar width as the user swipes through the gallery
    // (horizontal scroll on mobile only). The CSS keeps the wrapper hidden on
    // desktop, but we still hide it programmatically here when the gallery
    // has <2 medias (no swiping, no point in showing a progress bar).
    var progressEl = section.querySelector('[data-pdp-progress]');
    var progressFgEl = section.querySelector('[data-pdp-progress-fg]');

    function updateProgress() {
      if (!gallery || !progressFgEl) return;
      var max = gallery.scrollWidth - gallery.clientWidth;
      if (max <= 0) {
        progressFgEl.style.width = '0%';
        return;
      }
      var ratio = gallery.scrollLeft / max;
      progressFgEl.style.width = (ratio * 100).toFixed(2) + '%';
    }

    function refreshProgressVisibility() {
      if (!progressEl || !gallery) return;
      // Hide if the gallery is not scrollable (single media or all fits).
      var hasMultiple = gallery.scrollWidth > gallery.clientWidth + 1;
      progressEl.style.display = hasMultiple ? '' : 'none';
      updateProgress();
    }

    if (gallery && progressEl) {
      gallery.addEventListener('scroll', updateProgress, { passive: true });
      window.addEventListener('resize', refreshProgressVisibility);
      // Initial state + re-check after renderGallery rebuilds the DOM (variant
      // switch on a swatch click). MutationObserver fires once per innerHTML
      // replace, which is exactly when we need to recompute.
      var mo = new MutationObserver(refreshProgressVisibility);
      mo.observe(gallery, { childList: true });
      refreshProgressVisibility();
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
